angular.module('app').factory('productsService', [
    'Restangular',
    'settings',
    function (Restangular, settings) {
        var restAngular = Restangular.withConfig(function (Configurer)
        {
            Configurer.setBaseUrl(settings.apiURL);
        });

        var products = restAngular.all("/product/");
        return {
            getProducts: function (filters) {
                return products.
                    one("get").
                    customGET(param(filters))
            },
            update: function (requestData) {
                return products.
                    one("change").
                    post("", requestData)
            },
            saveImage: function (requestData) {
                return products.
                    one("saveImage").
                    post("", requestData)
            },
            deleteImage: function (requestData) {
                return products.
                    one("deleteImage").
                    customGET(param(requestData))
            },
            getDescription: function (requestData) {
                return products.
                    one("getDescription").
                    customGET(param(requestData))
            },
            changeOrder: function (requestData) {
                return products.
                one("changeOrder").
                post("", requestData)
            }
        }
    }
]);
